<div class="flex flex-row items-center gap-2">
  <button type="button" class="bm-btn bm-btn-sm gap-2" [cdkMenuTriggerFor]="tplColorMenu">
    @if (value) {
      <span class="inline-block w-4 h-4 rounded border border-base-300" [style.background-color]="value"></span>
      <span class="font-mono">{{ value }}</span>
    } @else {
      <span class="text-base-content/50">{{ emptyHint }}</span>
    }
    <i class="fa fa-caret-down"></i>
  </button>

  @if (value) {
    <button type="button" class="bm-btn bm-btn-ghost bm-btn-sm" (click)="clear()">Zurücksetzen</button>
  }
</div>

<!-- Auswahl erscheint erst im Popup, damit die Palette nicht wie ein Teil des Formulars wirkt -->
<ng-template #tplColorMenu>
  <div
    class="bm-dropdown-content bg-base-100 border border-base-300 rounded-box shadow-sm z-10 mt-1 p-3"
    cdkMenu
  >
    <div class="text-xs text-base-content/60 mb-2">Schnellauswahl</div>
    <div class="flex flex-row flex-wrap gap-2 max-w-56">
      @for (color of palette; track color) {
        <button
          type="button"
          cdkMenuItem
          class="w-6 h-6 rounded border cursor-pointer"
          [class.border-base-300]="!isSelected(color)"
          [class.border-base-content]="isSelected(color)"
          [class.ring-2]="isSelected(color)"
          [style.background-color]="color"
          [title]="color"
          (cdkMenuItemTriggered)="select(color)"
        ></button>
      }
    </div>

    <div class="border-t border-base-300 mt-3 pt-3 flex flex-row items-center gap-2">
      <label class="text-sm whitespace-nowrap">Eigene Farbe</label>
      <input
        type="color"
        class="w-10 h-8 rounded cursor-pointer border border-base-300"
        [ngModel]="value || placeholderColor"
        [ngModelOptions]="{ standalone: true }"
        (ngModelChange)="select($event)"
      />
    </div>
  </div>
</ng-template>
